import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import lang from './lang'
import vs from '../../../helper/vconsole'
import Rule from './Rule'
import http from 'src/helper/http'
import Message from 'src/component/Message'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    
  }
  state = {
    language: 'en',
    loading: false,
    loading2: false,
    openNotice: false,
    lang: lang.en,
    sendman: '',
    retry: false,
    inReview: false,
    noMoney: false,
    top: false,
    rightShow: false,
    inIndex: 0,
    leftShow: true,
    lastClick: 0,
    lastClickLeve: 99,
    clickLv: 1,
    giftList: [],
    userChange: '0',
    moveStartX:0,
    moveEndtX:0,
    day:10,
    hour:10,
    second:30,
    time:''
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
   
    this.setState({
      lang: setlang(language, lang),
      language: language
    })
    if (language == 'tr') {
      setDocumentTitle('Yakut Yükleme Teklifi')
    } else if (language == 'en') {
      setDocumentTitle('Ruby Recharge Offer')
    } else if (language == 'ar') {
      setDocumentTitle('عروض شحن الياقوت')
    }
    let uid = await setUidToken(this.props.location.query)
    this.rechargeRewardList()
    await this.RunOnStart(uid)
  }

  //需要uid才能执行的操作
  RunOnStart = async (uid) => {
    this.setState({
      uid: uid,
    })
    this.getGiftList()
  }

  setTop = (status) => {
    console.log(status)
    this.setState({
      top: status
    })
  }

  componentDidMount() {
      
  }

  hideRule = async (status) => {

    this.refs.rule.hideRule(status)
  }



  handleItem = (e, leve) => {
    this.setState({ inIndex: e, clickLv: leve })
    console.log(this.state.clickLv)
  }

  handleLeft = () => {
    let { clickLv, leftShow } = this.state
    if (leftShow) {
      this.setState({ leftShow: true, inIndex: clickLv - 1, })
    } else {
      this.setState({ leftShow: true, inIndex: clickLv - 1, })
    }

  }

  handleRight = () => {
    let { clickLv, rightShow } = this.state
    if (rightShow) {
      this.setState({ leftShow: false, inIndex: clickLv - 5, })
    } else {
      this.setState({ rightShow: true, leftShow: false, inIndex: 99 })
    }
  }

  getGiftList = async () => {
    let res = await http.post('/web/rechargerubyReward/list')
    if (res.code == 0) {
      this.setState({ giftList: res.res.list, userChange: res.res.monthlyTotal })
      if (Math.floor(res.res.monthlyTotal)>=4999) {
        await  this.setState({clickLv:8})
        this.handleRight()
      }else if(Math.floor(res.res.monthlyTotal)<4999 && Math.floor(res.res.monthlyTotal)>=2499) {
        await  this.setState({clickLv:7})
        this.handleRight()
      }else if(Math.floor(res.res.monthlyTotal)<2499 && Math.floor(res.res.monthlyTotal)>=1499) {
        await  this.setState({clickLv:6})
        this.handleRight()
      }else if(Math.floor(res.res.monthlyTotal)<1499 && Math.floor(res.res.monthlyTotal)>=999) {     
        await  this.setState({clickLv:5})
        this.handleRight()
      }else if(Math.floor(res.res.monthlyTotal)<999 && Math.floor(res.res.monthlyTotal)>=699) {
        await  this.setState({clickLv:4})
      }else if(Math.floor(res.res.monthlyTotal)<699 && Math.floor(res.res.monthlyTotal)>=299) {
        await  this.setState({clickLv:3})
      }else if(Math.floor(res.res.monthlyTotal)<299 && Math.floor(res.res.monthlyTotal)>=99) {
        await  this.setState({clickLv:2})
      }else if(Math.floor(res.res.monthlyTotal)<99) {
        await  this.setState({clickLv:1})
      }
    }
  }


  getLeveGift = async () => {
    let { giftList, clickLv, lang } = this.state
    let res = await http.post('/web/rechargerubyReward/getReward', { rechargeLevelId: giftList[clickLv - 1] && giftList[clickLv - 1].id })
    if (res.code == 0) {
      this.refs.msg.show(lang.successful)
      this.getGiftList()
    }
  }

  onChange = (currentSlide) => {
    console.log(currentSlide);
  };

  handelTouchStart = async(e) => {
    console.log('按钮开始', e.changedTouches[0].clientX);
    await this.setState({ moveStartX: e.changedTouches[0].clientX })
  }
  handelTouchend = async(e) => {
    let { moveStartX, clickLv } = this.state
    console.log('按钮结束', e.changedTouches[0].clientX);
    if ((moveStartX -e.changedTouches[0].clientX)>400 && clickLv<8)  {
      await this.setState({ moveEndX: e.changedTouches[0].clientX, clickLv:clickLv+1 })
      if (clickLv+1 >4) {
        this.handleRight()
      }
    }else if ((moveStartX -e.changedTouches[0].clientX)< (-400) && clickLv>1) {
      await this.setState({ moveEndX: e.changedTouches[0].clientX, clickLv:clickLv-1 })
      if (clickLv-1 <= 4) {
        this.handleLeft()
      }
    }
  }

 async rechargeRewardList(map, lang) {
   
    let d = await http.post('/web/rechargeReward/list', map)
    if (d && d.code == 0 ) {
      console.log(d.res)
      this.countDown(d.res.leftTimestamp)
    }

  }
  countDown = (times) => {
    let { lang } = this.state
    var timer = null
    timer = setInterval(
      () =>{
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = `${day}  ${lang.days} `
          
        }
        this.setState({
          time: daystr + hour + ':' + minute + ':' + second,
          day,
          hour,
          second
        })
        times--
       
      },
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }
  render() {
    let { language, lang, inIndex, leftShow, rightShow, clickLv, giftList, userChange, day, hour, second,time } = this.state
    return (
      <div className={`ruby-activity ${language == 'ar' ? 'arlang' : ''}`} >
        <div className='top-banner'>
          <div className="rules" onClick={this.hideRule.bind(this, true)}>
            {lang.rule}
          </div>
          <div className='banner-title'>
            {language == 'en' && <img src='/img/activity/ruby/banner_title_en.png' />}
            {language == 'tr' && <img src='/img/activity/ruby/banner_title_tr.png' />}
            {language == 'ar' && <img src='/img/activity/ruby/banner_title_ar.png' />}
            {language == 'zh' && <img src='/img/activity/ruby/banner_title_en.png' />}
          </div>

          <div className='grade-root' >
            <img className='left-click' src={language == 'ar' ? '/img/activity/ruby/icon_arrow_rigth.png' : '/img/activity/ruby/icon_arrow_left.png'} onClick={this.handleLeft}></img>
            <div className='grade-item'  >
              <div className='left-item' style={{ display: 'flex', marginLeft: `${!leftShow && language != 'ar' ? '-6rem' : ''}`, marginRight: `${!leftShow && language == 'ar' ? '-6rem' : ''}` }}>
                <div className='ri-item' key={1} onClick={() => this.handleItem(0, 1)}>
                  <div className={`${clickLv == 1 ? 'atv-lever-in' : 'lever-in'}`}>Lv.1</div>
                  <div className={`${clickLv == 1 ? 'atv-need-num' : 'need-num'}`}>$99</div>
                </div>
                <div className='ri-item' key={2} onClick={() => this.handleItem(1, 2)}>
                  <div className={`${clickLv == 2 ? 'atv-lever-in' : 'lever-in'}`}>Lv.2</div>
                  <div className={`${clickLv == 2 ? 'atv-need-num' : 'need-num'}`}>$299</div>
                </div>
                <div className='ri-item' key={3} onClick={() => this.handleItem(2, 3)}>
                  <div className={`${clickLv == 3 ? 'atv-lever-in' : 'lever-in'}`}>Lv.3</div>
                  <div className={`${clickLv == 3 ? 'atv-need-num' : 'need-num'}`}>$699</div>
                </div>
                <div className='ri-item' key={4} onClick={() => this.handleItem(3, 4)}>
                  <div className={`${clickLv == 4 ? 'atv-lever-in' : 'lever-in'}`}>Lv.4</div>
                  <div className={`${clickLv == 4 ? 'atv-need-num' : 'need-num'}`}>$999</div>
                </div>
              </div>
              <div className='right-item' style={{ display: 'flex' }}>
                <div className='ri-item' key={6} onClick={() => this.handleItem(0, 5)}>
                  <div className={`${clickLv == 5 ? 'atv-lever-in' : 'lever-in'}`}>Lv.5</div>
                  <div className={`${clickLv == 5 ? 'atv-need-num' : 'need-num'}`}>$1499</div>
                </div>
                <div className='ri-item' key={7} onClick={() => this.handleItem(1, 6)}>
                  <div className={`${clickLv == 6 ? 'atv-lever-in' : 'lever-in'}`}>Lv.6</div>
                  <div className={`${clickLv == 6 ? 'atv-need-num' : 'need-num'}`}>$2499</div>
                </div>
                <div className='ri-item' key={8} onClick={() => this.handleItem(2, 7)}>
                  <div className={`${clickLv == 7 ? 'atv-lever-in' : 'lever-in'}`}>Lv.7</div>
                  <div className={`${clickLv == 7 ? 'atv-need-num' : 'need-num'}`}>$4999</div>
                </div>
                <div className='ri-item' key={9} onClick={() => this.handleItem(3, 8)}>
                  <div className={`${clickLv == 8 ? 'atv-lever-in' : 'lever-in'}`}>Lv.8</div>
                  <div className={`${clickLv == 8 ? 'atv-need-num' : 'need-num'}`}>$9999</div>
                </div>
              </div>


            </div>
            <img className='left-click' src={language == 'ar' ? '/img/activity/ruby/icon_arrow_left.png' : '/img/activity/ruby/icon_arrow_rigth.png'} onClick={this.handleRight}></img>
          </div>
        </div>
       
        <div className='inthe-line'><div className='bg-line'></div>
          {[0, 1, 2, 3].map((item, index) => (<img key={index} src={inIndex == item ? '/img/activity/ruby/img_progress_selected.png' : '/img/activity/ruby/img_progress_normal.png'}></img>))}
        </div>
        <div className='time-down'><span className='text'>{lang.timeR}</span> {time}</div>
        <div className='gift-title'>
          <div className='text'>{lang.monthlyBenefits}</div>
        </div>
          <div className='in-root' onTouchStart={this.handelTouchStart} onTouchEnd={this.handelTouchend}>
            {giftList.map((i,idx)=>{ return (clickLv-1) == idx &&
            <div className='gift-list-ruby-activity'  key={idx}>
            {giftList.length > 0 && giftList[clickLv - 1] && giftList[clickLv - 1].rewardDetail.map((item, index) => (<div className='item-gigt-list' key={index} style={{ marginRight: `${language == 'ar' ? '' : '0.64rem'}`, marginLeft: `${language == 'ar' ? '0.64rem' : ''}` }}>
              <div className='item-gigt-list-img'><img src={language == 'ar' ? item.picAr || item.pic : language == 'tr' ? item.picTr || item.pic : item.pic}></img></div>
              {item.rewardType != 'gold' && item.rewardType != 'gift' && item.rewardType != 'duid'&& item.rewardType != 'custom_flash'&& item.rewardType != 'custom_gift'&&<div className='gift-time'>{language == 'ar' ? item.rewardNum+ 'يوم': language == 'tr' ? item.rewardNum + 'Gün' :item.rewardNum + 'day'  }</div>}
              {item.rewardType == 'gold' &&<div className='gift-time'>{item.rewardNum}</div>}
              {item.rewardType == 'gift' &&<div className='gift-time'>{item.rewardNum}</div>}
              {item.rewardType == 'custom_flash' &&<div className='gift-time'>{item.rewardNum}</div>}
              {item.rewardType == 'custom_gift' &&<div className='gift-time'>{item.rewardNum}</div>}
              {item.rewardType == 'duid' &&<div className='gift-time'>{item.rewardNum}</div>}
              <div className='text-root'>{language == 'ar' ? item.rewardNameAr || item.rewardName : language == 'tr' ? item.rewardNameTr || item.rewardName : item.rewardName}</div>
            </div>))}

          </div>
            })}
            
            {giftList[clickLv - 1] && !giftList[clickLv - 1].canGet && <div className='submit-btn'>{`${userChange}/${giftList[clickLv - 1] && giftList[clickLv - 1].rechargeAmount / 100}`}</div>}
            {giftList[clickLv - 1] && giftList[clickLv - 1].canGet && giftList[clickLv - 1].alreadyGet && <div className='youhaveget-btn'>{lang.received}</div>}
            {giftList[clickLv - 1] && giftList[clickLv - 1].canGet && !giftList[clickLv - 1].alreadyGet && <div className='nochange-btn' onClick={this.getLeveGift}>{lang.receive}</div>}
          </div>
        <div className='floor-root'></div>
        <Rule language={language} lang={lang} ref="rule" />
        <Message ref="msg" desc={this.state.desc} />
      </div>
    )
  }
}




// WEBPACK FOOTER //
// src/pages/activity/ruby-activity/index.js